module.exports = __webpack_public_path__ + "media/site_templates/www.buildingjobs.net.au/images/splash-de5c3649fa77773c7b4fe72beb76ae3c.jpg";